import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../../Components/StyledComponents/StyledComponents";

import { Modal, ModalClose, Sheet } from "@mui/joy";
import { formatNumber } from "../../config/common";

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${(p) => p.theme.spacing.sm};
  margin-top: ${(p) => p.theme.spacing.lg};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    flex-direction: column;
  }
`;
const CardWrapper = styled.div`
  width: calc(50% - 20px);
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: ${(p) => p.theme.spacing.sm};
    margin-top: 0;
  }
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: ${(p) => p.theme.spacing.sm};
    margin-top: 0;
  }
`;
const Card = styled.div`
  width: 100%;
  background-color: #151a1c;

  background-size: 100% 100%;
  background-position: right;
  padding: 0 20px;
  border-radius: ${(p) => p.theme.radius.xs};
  display: flex;
  align-items: center;

  ${(p) =>
    p.CardInitial &&
    `
  color:1px solid #88fefe;
  outline:none;
  border:none;
 `}
  ${(p) =>
    p.card2 &&
    `
 display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: start;
 `}

 ${(p) =>
    p.STACKINGCALCULATOR &&
    `

 background-image:none;
 background:none;
 `}

 ${(p) =>
    p.NftCalculator &&
    `
    width:100%;
 display:flex;
 flex-direction:column;
 justify-content:space-between;
 align-items:center;

 @media(max-width:768px){
display:flex;
flex-direction:column;
align-items:center;
 }
 `}
`;

const IconWrapper = styled.div`
  width: 40px;
  max-width: 40px;
  height: 40px;
  max-height: 40px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  :hover,
  :focus,
  :active {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  @media (min-width: 1600px) {
    width: 50px;
    height: 50px;
  }
`;
const Icon = styled.img`
  width: 20px;
  @media (min-width: 1600px) {
    width: 28px;
  }
`;
const Info = styled.div`
  margin-left: ${(p) => p.theme.spacing.sm};
`;
const Heading = styled.div`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  margin-bottom: ${(p) => p.theme.spacing.sm};
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    font-size: ${(p) => p.theme.font.size.md};
  }
  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
  @media (max-width: 1024px) {
    font-size: 24px;
    margin-bottom: 20px;
  }

  ${(p) =>
    p.STACKINGCALCULATOR &&
    ` 
    font-size:
      // ${(p) => p.theme.font.size.lg};
  font-family: 'Lato';
  color:white;
  padding : 0 20px;
  `}
`;
const Text = styled.div`
  color: ${(p) => p.theme.colors.lightskytextcolor};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.lg};
  }
`;
const BoldText = styled.div`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bold};
  /* margin-top: ${(p) => p.theme.spacing.xs}; */
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.xl};
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
  ${(p) =>
    p.Depositewrapper &&
    `
    width: "50%";
    display: flex;
    justify-content: flex-start;
   
 `}
`;

const WithDrawlButton = styled(Button)`
  border: none;
  color: #000;
  width: 100%;
  background: #e1e1e1;
  font-size: 18px;
  transition: 0.5s;
  &:hover {
    background: #1c3741;
    color: #208da5;
  }
`;
const IconStackedContainer = styled.div`
  display: flex;
  flex-direction: space-between;
`;
const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
`;
const Input = styled.input`
  padding: 10px 15px;
  font-size: 22px;
  width: 100% !important;
  margin: 0px;
  outline: none;
  border: none;
  border-radius: 25px;
  ${(p) =>
    p.PopUpText &&
    `
  font-size: 22px;

  `}
`;
const SelectWrapper = styled(InputWrapper)`
  width: 100%;
  /* margin: 20px 0 10px 0; */
`;
const SelectHeading = styled.text`
  font-size: 10px 15px;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 1.37rem;
  ${(p) =>
    p.PopUpText &&
    `
  
  color:white;
  font-size: 1.37rem;
  `}
`;
const Select = styled.select`
  padding: 10px 15px;
  width: 95% !important;
  margin: 0px;
  outline: none;
  border: none;
  font-size: 22px;
  border-radius: 25px;
  cursor: pointer;
`;
const LordRatioWrapper = styled.div`
  width: 100%;
  ${(p) =>
    p.NftCalculator &&
    `
  @media(max-width:1024px){
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width: 100%;
  }
`}
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const Option = styled.option`
  ${(p) =>
    p.PopUpText &&
    `
 font-size:22px;
 width: 100%;
  `}
`;
const LordpriceWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 5px;
`;

const TotalMldTentureAmountContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  /* margin: 0 5px; */

  @media (max-width: 1024px) {
    ${(p) =>
      p.NftCalculator &&
      `
  width:50%;
  `}
  }
  ${(p) =>
    p.NftCalculator &&
    `
  width:50%;
  @media(max-width:1024px){
    width:50%;
  }
  `}
`;

const DepositeContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px 0;
`;
const MaxButton = styled.button`
  padding: 12px 20px;
  border-radius: 25px;
  border: none;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  font-weight: 500;
  width: 95%;
`;

const CalculatorButtonWrapper = styled.div`
  margin: 20px 0 0 0;
`;
const CalculatorButton = styled.button`
  width: 100%;
  font-size: 18px;
  color: #88fefe;
  border: 1px solid #88fefe;
  background-color: transparent;
  cursor: pointer;
  border-radius: 25px;
  font-weight: 400;
  outline: none;
  padding: 15px;
`;

const CalculatorCardWrapper = styled.div`
  margin: 10px 0px;
  @media (max-width: 768px) {
  }
`;

const LineWrapper = styled.div`
  width: 100%;
`;
const Line = styled.div`
  width: 100%;
  height: 2px;
  border: 2px solid white;
  border-radius: 25px;
`;

const PreMaturityTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const PreMaturityText = styled.text`
  display: flex;
  text-align: start;
  font-size: 22px;
  /* width: 50%; */
  padding-bottom: 20px;
  color: white;
  display: flex;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;
const PreMaturityTextBig = styled.text`
  display: flex;
  text-align: start;
  font-size: 26px;
  /* width: 50%; */
  padding-bottom: 20px;
  font-weight: 600;
  color: white;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const PreMaturityContainer = styled.div`
  width: 100%;
  /* padding: 0 20px; */
`;

const ConfirmButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  width: 100%;
`;

const ConfirmButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ConfirmButton = styled.button`
  background: none;
  border: 1px solid #88fefe;
  border-radius: 25px;
  outline: none;
  color: #88fefe;
  font-weight: 500;
  cursor: pointer;
  margin: 10px 10px;
  font-size: 16px;
  /* width: 100%;      */
  padding: 15px 45px;
  font-size: 20px;

  ${(p) =>
    p.ConfirmButton &&
    `
    background-color: #88fefe;

    color: black;
`}
`;

const HashPoweWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: Center;
  width: 100%;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const HashPower = styled.input`
  padding: 15px 15px;
  border: none;
  outline: none;
  border-radius: 25px;
  color: #000;
  font-size: 16px;
  width: 100%;
`;
const HashSelectWrapper = styled.div`
  /* margin:0px 0 20px 0; */
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  justify-content: center;
  @media (max-width: 1024px) {
    width: 100%;
    margin: 0;
  }
`;

const HashText = styled.div`
  font-size: 10px 15px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 1.17rem;
  @media (max-width: 389px) {
    font-size: 14px !important;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 1366px) {
    font-size: 16px;
  }
`;
const HashButtonWrapper = styled.div`
  width: 50%;
  margin: 0 5px;
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    width: 50%;
    margin: 0 0 0 5px;
  }
`;
const WithdrawlWrapperContainer = styled.div`
  width: 100%;
  margin: 0px 0 30px 0;
  /* margin-top:30px; */
`;

const SheetMaterialuiStyle = styled(Sheet)`
  @media (max-width: 768px) {
    width: 330px !important;
    padding: 20px 0 0 !important;
  }
  @media (max-width: 1024px) {
    width: 330px !important;
    padding: 20px 0 0 !important;
  }
`;

const NftPoolStacking = (props) => {
  const [open, setOpen] = useState(false);
  const [withdrawl, setWithdrawl] = useState(false);
  const [userHash, setUserHash] = useState();
  const [totalPlateFormHash, setTotalPlateFormHash] = useState(100);
  const [totalMldDistribution, setTotalMldDistribution] = useState(100);

  const UserTotalHashHandler = (e) => {
    // setUserHash(e.target.value);
    const enterValue = e.target.value;

    if (enterValue < 0) {
      setUserHash(0);
    } else if (
      enterValue >= 0 &&
      enterValue <= props?.showdata?.totalHashRate
    ) {
      setUserHash(enterValue);
    } else {
      e.preventDefault();
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode ||  event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isCtrlPressed = event.ctrlKey || event.metaKey; // Check if Ctrl key is pressed

    if (
      keyCode === 8 || // Allow backspace key (key code 8)
      keyCode === 46 ||
      keyCode === 190 ||
      keyCode === 110 || 
      (keyCode >= 48 && keyCode <= 57) ||  // Allow numeric keys (0-9)
      (isCtrlPressed && keyValue === "r") || // Allow Ctrl+R combination
      keyCode === 37 || // Allow left arrow key (key code 37)
      keyCode === 39 // Allow right arrow key (key code 39)
    ) {
      // Check for plus (+) and minus (-) symbols
      if (keyValue === "+" || keyValue === "-") {
        event.preventDefault();
      }
    } else {
      event.preventDefault();
    }
  };
  // const UserTotalHashHandler = (e) => {
  //   const enteredValue = e.target.value

  //   if (enteredValue < 0) {
  //     setUserHash(0);
  //   } else {
  //     setUserHash(enteredValue);
  //   }
  // };
  return (
    <Root>
      {/* <CardWrapper> */}
      {/* <Heading>HARVEST</Heading> */}
      {/* <Card card2="card2">
          <IconStackedContainer>
            <IconWrapper>
              <Icon src={Icons.SmartIcon} />
            </IconWrapper>
            <Info>
              <Text>Total Staked NFT</Text>
              <BoldText>
               {parseFloat(userBalance?.MLD || 0).toFixed(2)}
                4,234,453
              </BoldText>
            </Info>
          </IconStackedContainer>

          <ButtonWrapper onClick={() => setWithdrawl(true)}>
            <WithDrawlButton
              bdcolor="#464033"
              color="#464033"
              radius="xl"
              top="xs"
              bottom="xs"
              left="sm"
              right="sm"
            >
              Unstake
            </WithDrawlButton>
          </ButtonWrapper>
          <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={withdrawl}
            onClose={() => setWithdrawl(false)}
            size="full"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Sheet
              variant="outlined"
              sx={{
                maxWidth: 380,
                borderRadius: "md",
                p: 3,
                boxShadow: "lg",
              }}
              style={{ backgroundColor: "#1e001e" }}
            >
              <ModalClose
                variant="outlined"
                sx={{
                  top: "calc(-1/4 * var(--IconButton-size))",
                  right: "calc(-1/4 * var(--IconButton-size))",
                  boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                  borderRadius: "50%",
                  bgcolor: "background.body",
                }}
              />
              <CalculatorCardWrapper styled={{margin:"0 20px"}}>
                <Heading STACKINGCALCULATOR> Review </Heading>
                <Card
                  STACKINGCALCULATOR
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <PreMaturityContainer>
                    <PreMaturityTextWrapper>
                      <PreMaturityText>Total Staked Amount</PreMaturityText>
                      <PreMaturityTextBig> : 10200</PreMaturityTextBig>
                    </PreMaturityTextWrapper>
                    <PreMaturityTextWrapper>
                      <PreMaturityText>Withdrawl Fee(6%) </PreMaturityText>
                      <PreMaturityTextBig> : 100.00</PreMaturityTextBig>
                    </PreMaturityTextWrapper>
                    <PreMaturityTextWrapper>
                      <PreMaturityText>Total Maturity Amount </PreMaturityText>
                      <PreMaturityTextBig> : 10100</PreMaturityTextBig>
                    </PreMaturityTextWrapper>
                  </PreMaturityContainer>
                  <ConfirmButtonContainer>
                    <ConfirmButtonWrapper>
                      <ConfirmButton onClick={() => setWithdrawl(false)}>
                        Cancel
                      </ConfirmButton>
                    </ConfirmButtonWrapper>
                    <ConfirmButtonWrapper>
                      <ConfirmButton ConfirmButton>Confirm</ConfirmButton>
                    </ConfirmButtonWrapper>
                  </ConfirmButtonContainer>
                </Card>
              </CalculatorCardWrapper>
            </Sheet>
          </Modal>
        </Card> */}

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SheetMaterialuiStyle
          variant="outlined"
          sx={{
            width: 600,
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
          }}
          style={{ backgroundColor: "rgb(22 36 42 / 92%)" }}
        >
          <ModalClose
            variant="outlined"
            sx={{
              top: "calc(-1/4 * var(--IconButton-size))",
              right: "calc(-1/4 * var(--IconButton-size))",
              boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
              borderRadius: "50%",
              bgcolor: "background.body",
            }}
          />
          <CalculatorCardWrapper>
            <Heading STACKINGCALCULATOR>Staking Hash Calculator </Heading>
            <Card
              STACKINGCALCULATOR
              style={{ display: "flex", flexDirection: "column" }}
            >
              {/* <TotalMldTentureAmountContainer>
                  <LordRatioWrapper>
                    <InputWrapper>
                      <SelectHeading PopUpText> User Hash </SelectHeading>
                      <Input 
                      PopUpText type="number" 
                      placeholder="10" 
                      value={userHash}
                      onChange={(e)=>{
                        setUserHash(e.target.value)
                      }}
                      />
                    </InputWrapper>
                    <LordpriceWrapper></LordpriceWrapper>
                  </LordRatioWrapper>
                </TotalMldTentureAmountContainer> */}

              <DepositeContainer>
                <LineWrapper>
                  <Line />
                </LineWrapper>
              </DepositeContainer>
              <PreMaturityContainer>
                {/* <PreMaturityTextWrapper>
                  <PreMaturityText> Platform Total Hash:</PreMaturityText>
                  <PreMaturityTextBig>
                    {" "}
                    {props?.showdata?.totalHashRate}{" "}
                  </PreMaturityTextBig>
                </PreMaturityTextWrapper>
                <PreMaturityTextWrapper>
                  <PreMaturityText>User Total Hash: </PreMaturityText>
                  <PreMaturityTextBig> {props.userHash} </PreMaturityTextBig>
                </PreMaturityTextWrapper>
                <PreMaturityTextWrapper>
                  <PreMaturityText>Rewards Percentage:</PreMaturityText>
                  <PreMaturityTextBig>
                    {" "}
                    {(userHash / totalPlateFormHash) *
                      totalMldDistribution} %{" "}
                  </PreMaturityTextBig>
                </PreMaturityTextWrapper> */}
                <PreMaturityTextWrapper>
                  <PreMaturityText> Estimated Return:</PreMaturityText>
                  <PreMaturityTextBig>
                    
                    {`${formatNumber((totalMldDistribution / props?.showdata?.totalHashRate) *
                      userHash)} $MLD / day`}
                  </PreMaturityTextBig>
                </PreMaturityTextWrapper>
              </PreMaturityContainer>
            </Card>
          </CalculatorCardWrapper>
        </SheetMaterialuiStyle>
      </Modal>

      {/* </CardWrapper> */}

      <CardWrapper style={{ marginBottom: "30px" }}>
        {/* <Heading> NFT calculator </Heading> */}
        <Heading> Staking calculator </Heading>
        <Card NftCalculator>
          <div style={{ display: "flex", marginTop: "20px", width: "100%" }}>
            <TotalMldTentureAmountContainer NftCalculator>
              <LordRatioWrapper NftCalculator>
                <HashSelectWrapper>
                  <HashText> Total Hash Power </HashText>
                  <HashPoweWrapper>
                    <HashPower
                      type="number"
                      placeholder=""
                      value={props?.showdata?.totalHashRate}
                    />
                  </HashPoweWrapper>
                </HashSelectWrapper>
              </LordRatioWrapper>
            </TotalMldTentureAmountContainer>
            <HashButtonWrapper>
              <LordRatioWrapper>
                <HashSelectWrapper>
                  <HashText> My Hash Power </HashText>
                  <HashPoweWrapper>
                    <HashPower
                      type="number"
                      placeholder=""
                      max={props?.showdata?.totalHashRate}
                      value={userHash}
                      onChange={UserTotalHashHandler}
                      onKeyDown={handleKeyPress}
                    />
                  </HashPoweWrapper>
                </HashSelectWrapper>
              </LordRatioWrapper>
            </HashButtonWrapper>
          </div>
          <WithdrawlWrapperContainer>
            <WithDrawlButton
              Claim
              bdcolor="#464033"
              color="#464033"
              radius="xl"
              top="xs"
              bottom="xs"
              left="sm"
              right="sm"
              onClick={() => setOpen(true)}
              disabled = {props?.showdata?.totalHashRate  && userHash ?  false: true}
            >
              Calculate
            </WithDrawlButton>
          </WithdrawlWrapperContainer>
        </Card>
      </CardWrapper>
    </Root>
  );
};

export default NftPoolStacking;
